import {emotionStyled, tokens} from '@packages/utilities/styled';

export const NumberInputSuffixView = emotionStyled('div')(
  {
    display: 'flex',
    alignItems: 'center',
    background: '$uiInputBackground',
    borderTop: '$border2',
    borderBottom: '$border2',
    borderRight: '$border2',
    borderRadius: '0 $2 $2 0',
    fontSize: '$body',
    lineHeight: '$body',
    paddingRight: tokens.ui.numberInput.input.withPrefixOrSuffix.paddingX,
  },
  {
    componentName: 'NumberInputSuffix',
    variants: {
      shouldShowTrailingControls: {
        true: {
          borderRadius: '0',
          borderRight: 'none',
        },
      },
    },
  }
);
